import React from "react";

const SqlLogo = () => {
    return (
        <svg width="512" height="512" x="0" y="0" viewBox="0 0 60 60">
            <g>
                <g fill="none" fillRule="nonzero">
                    <path
                        fill="#02a9f4"
                        d="M27 42.17v8c-2.63.562-5.311.84-8 .83-9.94 0-18-3.58-18-8v-8c0 4.42 8.06 8 18 8 2.689.01 5.37-.268 8-.83z"
                        opacity="1"
                        dataoriginal="#02a9f4"
                    ></path>
                    <path
                        fill="#0377bc"
                        d="M24 42.674v7.5a36.985 36.985 0 0 1-6.611.794 40.71 40.71 0 0 0 1.611.036c2.689.01 5.37-.268 8-.83v-8c-.951.205-1.962.367-3 .5z"
                        opacity="1"
                        dataoriginal="#0377bc"
                    ></path>
                    <path
                        fill="#02a9f4"
                        d="M37 26v11h-8a2.006 2.006 0 0 0-2 2v3.17c-2.63.562-5.311.84-8 .83-9.94 0-18-3.58-18-8v-9c0 4.42 8.06 8 18 8s18-3.58 18-8z"
                        opacity="1"
                        dataoriginal="#02a9f4"
                    ></path>
                    <path
                        fill="#0377bc"
                        d="M24 39v3.17a36.985 36.985 0 0 1-6.611.794A40.71 40.71 0 0 0 19 43c2.689.01 5.37-.268 8-.83V39a2.006 2.006 0 0 1 2-2h-3a2.006 2.006 0 0 0-2 2zM34 30.419V37h3V26c0 1.635-1.108 3.153-3 4.419z"
                        opacity="1"
                        dataoriginal="#0377bc"
                    ></path>
                    <path
                        fill="#02a9f4"
                        d="M37 17v9c0 4.42-8.06 8-18 8S1 30.42 1 26v-9c0 4.42 8.06 8 18 8s18-3.58 18-8z"
                        opacity="1"
                        dataoriginal="#02a9f4"
                    ></path>
                    <path
                        fill="#0377bc"
                        d="M34 21.419V26c0 4.2-7.263 7.627-16.5 7.966.5.019.994.034 1.5.034 9.94 0 18-3.58 18-8v-9c0 1.635-1.108 3.153-3 4.419z"
                        opacity="1"
                        dataoriginal="#0377bc"
                    ></path>
                    <path
                        fill="#02a9f4"
                        d="M37 9v8c0 4.42-8.06 8-18 8S1 21.42 1 17V9c0-4.42 8.06-8 18-8s18 3.58 18 8z"
                        opacity="1"
                        dataoriginal="#02a9f4"
                    ></path>
                    <path
                        fill="#0377bc"
                        d="M19 1c-.506 0-1 .015-1.5.034C26.737 1.373 34 4.805 34 9v8c0 4.2-7.263 7.627-16.5 7.966.5.019.994.034 1.5.034 9.94 0 18-3.58 18-8V9c0-4.42-8.06-8-18-8z"
                        opacity="1"
                        dataoriginal="#0377bc"
                    ></path>
                    <rect
                        width="32"
                        height="22"
                        x="27"
                        y="37"
                        fill="#ffdc00"
                        rx="2"
                        opacity="1"
                        dataoriginal="#ffdc00"
                    ></rect>
                    <path
                        fill="#fec108"
                        d="M57 37h-3a2.006 2.006 0 0 1 2 2v18a2.006 2.006 0 0 1-2 2h3a2.006 2.006 0 0 0 2-2V39a2.006 2.006 0 0 0-2-2z"
                        opacity="1"
                        dataoriginal="#fec108"
                    ></path>
                    <ellipse
                        cx="19"
                        cy="10"
                        fill="#0377bc"
                        rx="13"
                        ry="5"
                        opacity="1"
                        dataoriginal="#0377bc"
                    ></ellipse>
                    <g fill="#000">
                        <path
                            d="M19 16c6.787 0 14-2.1 14-6s-7.213-6-14-6S5 6.1 5 10s7.213 6 14 6zm0-10c7.435 0 12 2.33 12 4s-4.565 4-12 4-12-2.33-12-4 4.565-4 12-4z"
                            fill="#000000"
                            opacity="1"
                            dataoriginal="#000000"
                        ></path>
                        <path
                            d="M57 36H38V9c0-5.047-8.346-9-19-9S0 3.953 0 9v34c0 5.047 8.346 9 19 9 2.347.004 4.69-.205 7-.623V57a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V39a3 3 0 0 0-3-3zm-28 0a3 3 0 0 0-3 3v2.341c-2.307.443-4.65.664-7 .659-10.169 0-17-3.619-17-7v-4.936C5.086 33.013 11.455 35 19 35s13.914-1.987 17-4.936V36zm7-10c0 3.381-6.831 7-17 7S2 29.381 2 26v-4.936C5.086 24.013 11.455 26 19 26s13.914-1.987 17-4.936zM2 9c0-3.381 6.831-7 17-7s17 3.619 17 7v8c0 3.381-6.831 7-17 7S2 20.381 2 17zm17 41C8.831 50 2 46.381 2 43v-3.936C5.086 42.013 11.455 44 19 44c2.347.004 4.69-.205 7-.624v5.965c-2.307.444-4.65.664-7 .659zm39 7a1 1 0 0 1-1 1H29a1 1 0 0 1-1-1V39a1 1 0 0 1 1-1h28a1 1 0 0 1 1 1z"
                            fill="#000000"
                            opacity="1"
                            dataoriginal="#000000"
                        ></path>
                        <path
                            d="M34.5 44H37a1 1 0 0 0 0-2h-2.5a3.5 3.5 0 0 0 0 7 1.5 1.5 0 0 1 0 3H32a1 1 0 0 0 0 2h2.5a3.5 3.5 0 0 0 0-7 1.5 1.5 0 0 1 0-3zM47.753 51.339c.159-.429.242-.882.247-1.339v-4a4 4 0 1 0-8 0v4a3.979 3.979 0 0 0 6.6 3.015l.693.692a1 1 0 0 0 1.414-1.414zM44 52a2 2 0 0 1-2-2v-4a2 2 0 1 1 4 0v3.586l-.293-.293a1 1 0 0 0-1.414 1.414l.894.894A1.985 1.985 0 0 1 44 52zM55 52h-2v-9a1 1 0 0 0-2 0v10a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2z"
                            fill="#000000"
                            opacity="1"
                            dataoriginal="#000000"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default SqlLogo;
